import {svgIconWrapper} from '../svg-icon-wrapper';

import BoxRegularReport from './box-regular-report-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BoxRegularReport {...validProps} />;
}

SvgComponent.iconName = 'boxRegularReport';

export const BoxRegularReportIcon = svgIconWrapper(SvgComponent);
